import PropTypes from 'prop-types';

export const childrenType = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.func,
]);

export const baseColors = ['mint', 'blue', 'red', 'orange'];
export const colorType = PropTypes.oneOf(baseColors);

export const classNameType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);

export const getColorType = (additionalColors) => {
  const toArray = Array.isArray(additionalColors) ? additionalColors : [additionalColors];
  return PropTypes.oneOf([...baseColors, ...toArray]);
};
